import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from '../../../../providers/root-store-provider';
import { Dropdown } from '../../dropdown/dropdown';
import { Responsive } from '../../responsive/responsive';
import { PortfolioMenu } from '../menu/portfolio-menu';
import { IconArrowDown } from '../../icons/arrow-down';
import { PortfolioMenuMobile } from '../menu/mobile/portfolio-menu-mobile';
import { IconPortfolio } from '../../icon/portfolio/icon-portfolio';
import { HeaderButtonPrivate } from '../../../../blocks/app/header/button/private/header-button-private';
import { cn } from '../../../../utils/tailwind';

export const PortfolioSwitcher: React.FC = observer(() => {
    const { portfolioStore, themeStore } = useRootStore();
    const myPortfolio = portfolioStore.selectedPortfolio;

    const menuIndicatorClassName = 'flex h-[3rem] items-center gap-xsmall xl:h-[4rem]';

    return (
        <div className="flex items-center gap-xsmall md:gap-vsmall">
            <Responsive breakpoint="md">
                <Dropdown position={'bottom-left'} content={<PortfolioMenu />}>
                    <div className={menuIndicatorClassName}>
                        <IconPortfolio type={myPortfolio.iconName} size="medium" variant={myPortfolio.colorName} />
                        <div className="text-medium leading-medium font-bold text-text overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical]">
                            {myPortfolio.name}
                        </div>
                        <IconArrowDown />
                    </div>
                </Dropdown>
            </Responsive>
            <Responsive breakpoint="md" type="max">
                <div
                    className={menuIndicatorClassName}
                    onClick={() => {
                        themeStore.toggleMobilePortfolioNavigationDisplay();
                        themeStore.hideMobileNavigation();
                    }}
                >
                    <IconPortfolio type={myPortfolio.iconName} size="medium" variant={myPortfolio.colorName} />
                    <IconArrowDown />
                </div>
            </Responsive>
            <div
                className={cn(
                    'absolute left-0 right-0 top-full max-h-[calc(100vh-6.2rem)] overflow-auto border-t border-border bg-header shadow-[inset_0px_-1px_0px_rgba(153,153,153,0.16)]',
                    themeStore.mobilePortfolioNavigationDisplay ? 'block' : 'hidden',
                )}
            >
                <PortfolioMenuMobile />
            </div>
            <div className="relative h-auto w-[0.1rem] self-stretch bg-border" />
            <HeaderButtonPrivate />
        </div>
    );
});
